(function () {
  if (window.__artworkEnquiryInstalled) {
    return;
  }

  window.__artworkEnquiryInstalled = true;

  function getShopifyChatButton() {
    const chatElement = document.querySelector('shopify-chat');

    if (!chatElement) {
      return null;
    }

    if (!chatElement.shadowRoot) {
      return null;
    }

    const button =
      chatElement.shadowRoot.querySelector('button.activator') ||
      chatElement.shadowRoot.querySelector('button[part="activator"]') ||
      chatElement.shadowRoot.querySelector('button[aria-label="Open chat"]');

    return button || null;
  }

  function openShopifyChat() {
    let attempts = 0;
    const maxAttempts = 30;

    const tryOpen = function () {
      attempts += 1;

      const chatButton = getShopifyChatButton();

      if (chatButton) {
        const expanded = chatButton.getAttribute('aria-expanded');

        if (expanded !== 'true') {
          chatButton.click();
        }

        return;
      }

      if (attempts < maxAttempts) {
        setTimeout(tryOpen, 100);
      } else {
        console.warn(
          'Artwork enquiry: Shopify chat button could not be found.'
        );
      }
    };

    tryOpen();
  }

  document.addEventListener('click', function (event) {
    const enquiryButton = event.target.closest(
      '.artwork-enquiry__button'
    );

    if (!enquiryButton) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    openShopifyChat();
  });
})();